"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CreditCardValidator = require("./CreditCardValidator");
Object.keys(_CreditCardValidator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreditCardValidator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CreditCardValidator[key];
    }
  });
});